import React, {Component} from 'react'
import GenerateTemplateByQuery from './actions/GenerateTemplateByQuery'
import BulkMarkAsPrinted from './actions/BulkMarkAsPrinted'
import {Button, Dropdown, Icon, Menu} from 'antd'
import bulkExportLinks from './actions/bulkExportLinks'
import bulkExportLinksPosterCanvas from './actions/bulkExportLinksPosterCanvas'
import ExportLinksByName from './actions/ExportLinksByName'
import bulkExportRepairedLink from './actions/bulkExportRepairedLink'
import CreateBatch from './actions/CreateBatchV2'
import CreateBatchList from './actions/CreateBatchListV2'
import PropTypes from "prop-types"

class OrdersQueryActions extends Component {
    state = {
        action: '',
    }

    _handleClick = ({key}) => {
        if ('bulkAction3' === key) {
            bulkExportLinks(this.props)
            return
        } else if ('bulkAction5' === key) {
            bulkExportRepairedLink()
            return
        } else if ('bulkAction6' === key) {
            bulkExportLinksPosterCanvas(this.props)
            return
        }

        this.setState({
            action: key,
        })
    }

    _renderAction = () => {
        switch (this.state.action) {
            case 'bulkAction2':
                return <BulkMarkAsPrinted onResetAction={this._resetAction}/>
            case 'bulkAction1':
                return <GenerateTemplateByQuery {...this.props} onResetAction={this._resetAction}/>
            case 'bulkAction4':
                return <ExportLinksByName onResetAction={this._resetAction}/>
            case 'bulkAction7':
                return <CreateBatch {...this.props} onResetAction={this._resetAction}/>
            case 'bulkAction8':
                return <CreateBatchList {...this.props} onResetAction={this._resetAction}/>
            default:
                return ''
        }
    }

    _menu = (
        <Menu onClick={this._handleClick} selectable={false}>
            {/* <Menu.Item key='bulkAction1'>Tạo file in</Menu.Item>
            <Menu.Item key='bulkAction2'>Đánh dấu đã in</Menu.Item> */}
            <Menu.Item key='bulkAction7'>Tạo lô theo số lượng</Menu.Item>
            <Menu.Item key='bulkAction8'>Tạo lô theo danh sách</Menu.Item>
            {/* <Menu.Item key='bulkAction3'>Xuất link files</Menu.Item>
            <Menu.Item key='bulkAction4'>Xuất link files theo tên</Menu.Item>
            <Menu.Item key='bulkAction5'>Xuất link files đã sửa</Menu.Item>
            <Menu.Item key='bulkAction6'>Xuất link files poster & canvas</Menu.Item> */}
        </Menu>
    )

    _resetAction = () => {
        this.setState({
            action: '',
        })
    }

    render() {
        const action = this._renderAction()
        const {loading} = this.props

        return (
            <div className='OrdersQueryActions'>
                <Dropdown disabled={loading} overlay={this._menu} trigger={['click']}>
                    <Button>
                        Bulk actions <Icon type="down"/>
                    </Button>
                </Dropdown>

                {action}
            </div>
        )
    }
}

OrdersQueryActions.defautlProps = {
    loading: false
}

OrdersQueryActions.propTypes = {
    loading: PropTypes.bool,
}

export default OrdersQueryActions
